import React from "react";
import "./LoadingScreen.css"; // Include the CSS for the loading screen

const LoadingScreen = () => {
  return (
    <div className="loading-screen">
      <div className="spinner">
        <div className="double-bounce1"></div>
        <div className="double-bounce2"></div>
      </div>
      <div class="loader"></div>
    </div>
  );
};

export default LoadingScreen;
